var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vin-search"},[_c('h3',{staticClass:"vin-search__title"},[_vm._v("Каталоги автозапчастей")]),_c('vin-search-form',{staticClass:"vin-search__form"}),_c('vin-search-help',{staticClass:"vin-search__help"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }